import * as ModuleClass from './../../_function/class.js';

// password_interface.js

function updatePasswordInput(e, isUserInvoked, isKeyEvent, passwordContainer, passwordInput, iconShift, iconCapslock, iconShow) {
  var space = 0;
  // var space = [ 0, 0 ];

  if ( iconShift )
  {
    if ( isUserInvoked && isKeyEvent && e.getModifierState('Shift') == true )
    {
      ModuleClass.removeClass(iconShift, 'login__password__icon--hidden');
      space += iconShift.offsetWidth + parseInt( ( iconShift.currentStyle || window.getComputedStyle(iconShift) ).marginRight );
      // space[0] += iconShift.offsetWidth + parseInt( ( iconShift.currentStyle || window.getComputedStyle(iconShift) ).marginRight );
      // space[0] += iconShift.offsetWidth + parseInt( ( iconShift.currentStyle || window.getComputedStyle(iconShift) ).marginRight ) - 1; // -1 so it does not hide the caret for some reason
    }
    else ModuleClass.addClass(iconShift, 'login__password__icon--hidden');
  }

  if ( iconCapslock )
  {
  	if ( isUserInvoked && isKeyEvent && e.getModifierState('CapsLock') == true )
    {
      ModuleClass.removeClass(iconCapslock, 'login__password__icon--hidden');
      space += iconCapslock.offsetWidth + parseInt( ( iconCapslock.currentStyle || window.getComputedStyle(iconShift) ).marginRight );
      // space[0] += iconCapslock.offsetWidth + parseInt( ( iconCapslock.currentStyle || window.getComputedStyle(iconShift) ).marginRight );
      // space[0] += iconCapslock.offsetWidth + parseInt( ( iconCapslock.currentStyle || window.getComputedStyle(iconShift) ).marginRight ) - 1; // -1 so it does not hide the caret for some reason
    }
    else ModuleClass.addClass(iconCapslock, 'login__password__icon--hidden');
  }

  if ( !isKeyEvent ) updatePasswordVisibility( false, false, passwordInput, iconShow );

  if ( passwordInput.value )
  {
    // ModuleClass.addClass(passwordInput, 'password__feedback--filled');
    if ( passwordInput.interacted && isUserInvoked )
    {
      ModuleClass.removeClass(iconShow, 'login__password__icon--hidden');
      space += iconShow.offsetWidth + (space ? parseInt( ( iconCapslock.currentStyle || window.getComputedStyle(iconShift) ).marginLeft ) : 0) - 8;
      // space[1] += iconShow.offsetWidth + (space[1] ? parseInt( ( iconCapslock.currentStyle || window.getComputedStyle(iconShift) ).marginLeft ) : 0) - 8;
      // space[1] += iconShow.offsetWidth + (space[1] ? parseInt( ( iconCapslock.currentStyle || window.getComputedStyle(iconShift) ).marginLeft ) : 0) - 8 - 1; // -1 so it does not hide the caret for some reason
    }
  }
  else
  {
    // ModuleClass.removeClass(passwordInput, 'password__feedback--filled');
    if ( isUserInvoked ) ModuleClass.addClass(iconShow, 'login__password__icon--hidden');
  }

  // modify inside of text input:
  // if ( space[0] ) passwordInput.style.paddingRight = ( space[0] + 8 ) + 'px'; // 8 hides the caret for some reason
  // else passwordInput.style.paddingRight = '';

  // modify outside of text input:
  passwordContainer.style.paddingRight = (space ? space + 8 : 0) + 'px';
  // passwordContainer.style.paddingRight = (space[1] ? space[1] + 8 : 0) + 'px';

  // keep caret visible while shifting right border:
  if( passwordInput == document.activeElement )
    passwordInput.setSelectionRange(passwordInput.selectionStart, passwordInput.selectionEnd);
}

function updatePasswordVisibility( e, show, passwordInput, iconShow ) {
  if ( show && passwordInput.interacted )
  {
    if ( e ) e.preventDefault();
    if ( passwordInput.type !== 'text' )
    {
      passwordInput.type = 'text';
      ModuleClass.addClass(iconShow, 'login__password__icons__show--active');
    }
  }
  else
  {
    if ( passwordInput.type !== 'password' ) passwordInput.type = 'password';
    ModuleClass.removeClass(iconShow, 'login__password__icons__show--active');
  }
}

let isIOS = (/iPad|iPhone|iPod/.test(navigator.platform) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
  !window.MSStream;

function setupPasswordInterface(passwordContainer) {
  var passwordInput     = passwordContainer.getElementsByTagName('input')[0];

  if ( !passwordInput || passwordInput.type !== 'password' ) return;

  passwordInput.addEventListener('copy', function(e) { e.preventDefault(); }); // prevent people from stealing autofill passwords :)
  passwordInput.addEventListener('cut',   function(e) { e.preventDefault(); });

  // if(!isIOS) {
  var iconShift    = isIOS ? false : passwordContainer.getElementsByClassName('login__password__icons__shift')[0];
  var iconCapslock = isIOS ? false : passwordContainer.getElementsByClassName('login__password__icons__capslock')[0];
  var iconShow     = passwordContainer.getElementsByClassName('login__password__icons__show')[0];

  passwordInput.addEventListener('focusin',   function(e) { // prevent people from stealing autofill passwords :)
    if ( !this.interacted ) {
      passwordInput.value = '';
      this.interacted = true;
      // ModuleClass.removeClass(passwordInput, 'password__feedback--filled');
    }
  });
  passwordInput.addEventListener('focusout',  function(e) {
    updatePasswordVisibility( e, false, passwordInput, iconShow );
    updatePasswordInput( e, true, false, passwordContainer, passwordInput, iconShift, iconCapslock, iconShow );
  });
  passwordInput.addEventListener('mousedown', function(e) { updatePasswordInput( e, true, true, passwordContainer, passwordInput, iconShift, iconCapslock, iconShow ); });
  passwordInput.addEventListener('keydown',   function(e) { updatePasswordInput( e, true, true, passwordContainer, passwordInput, iconShift, iconCapslock, iconShow ); });
  passwordInput.addEventListener('keyup',     function(e) { updatePasswordInput( e, true, true, passwordContainer, passwordInput, iconShift, iconCapslock, iconShow ); });
  // }

  iconShow.addEventListener('mousedown',  function(e) { updatePasswordVisibility( e, true, passwordInput, iconShow ); });
  iconShow.addEventListener('mouseup',    function(e) { updatePasswordVisibility( e, false, passwordInput, iconShow ); });
  iconShow.addEventListener('mouseleave', function(e) { updatePasswordVisibility( e, false, passwordInput, iconShow ); });

  iconShow.addEventListener('touchstart', function(e) { updatePasswordVisibility( e, true, passwordInput, iconShow ); });
  iconShow.addEventListener('touchend',   function(e) { updatePasswordVisibility( e, false, passwordInput, iconShow ); });
  iconShow.addEventListener('touchleave', function(e) { updatePasswordVisibility( e, false, passwordInput, iconShow ); });

  updatePasswordInput( false, false, false, passwordContainer, passwordInput, iconShift, iconCapslock, iconShow );
}

function setupPasswordInterfaces(className) {
  var passwordContainers = document.getElementsByClassName(className);

  for (var i = 0; i < passwordContainers.length; i++) {
    var passwordContainer = passwordContainers[i];

    setupPasswordInterface(passwordContainer);
  }
}

setupPasswordInterfaces('login__password__icons-container');
